import FormInputNumberInput from './component.jsx'
export default FormInputNumberInput
